import * as React from 'react';
import { Container, Grid, Button } from "@mui/material";
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import EditarPerfilCotizadorModal from './EditarPerfilCotizadorModal';
import AxaSeguro from '../../assets/img/planesCotizacion/logo-axa.svg';
import GDSSeguro from '../../assets/img/planesCotizacion/logo-general-de-salud.svg';
import gnp from '../../assets/img/planesCotizacion/logo-gnp.svg';
import mapfre from '../../assets/img/planesCotizacion/logo-mapfre.svg';
import './PlanesCotizacion.css'



export default function PlanesCotizacion(props) {
    const dataObj = JSON.parse(sessionStorage.getItem("interContratante"))
    const [expanded, setExpanded] = React.useState(false);
    const [cobertura, setCobertura] = React.useState('');
    const [name, setName] = React.useState(dataObj.nombre);
    const [dateOfBirht, setDateOfBirth] = React.useState(dataObj.fechaNacimiento);
    const [contactType, setContactType] = React.useState('');
    const [pregnant, setPregnant] = React.useState(dataObj.embarazo);
    const [phone, setPhone] = React.useState(dataObj.telefono);
    const [email, setEmail] = React.useState(dataObj.correo);
    const [gender, setGender] = React.useState(dataObj.genero);

    console.log("Session Name", sessionStorage.getItem("interContratante"))

    const bgWhite = {
        backgroundColor: "#FFF",
        padding: "2%",
        borderRadius: "12px",
        marginButtom: "2%",
        with: "1140px"
    }
    const bgTransparent = {
        backgroundColor: 'transparent',
    }

    const opcionesAseguradoStyle = {
        backgroundColor: "#F2FAFC",
        borderRadius: "6px",
        padding: "3%",
        with: "97%",
    }
    const opcionesAseguradoStyleMobile = {
        backgroundColor: "#F4F4F4",
        borderRadius: "6px",
        padding: "3%",
        with: "97%",
    }
    const aseguradoAdicionalesStyle = {
        backgroundColor: '#ddf2f7',
        minHeight: "57px",
        paddingTop: "15px",
    }

    const fondoStyle = {
        minHeight: "700px",
        height: "100%",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        backgroundColor: "#f4f4f4",
        // zIndex: "-50"
    };
    const fondoStyleMobile = {
        height: "100%",
        backgroundColor: '#f5f5f5',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
    };
    const styleTextAseguradosAdicionales = {
        fontWeight: 600,
    }

    // const setParametersAsegurados = () => {
    //     const dataObj = sessionStorage.getItem("interContratante");
    //     console.log("Data obj:", dataObj)
    //     setName(dataObj.nombre);
    //     // setDateOfBirth(dataObj.fechaNacimiento)
    //     // setGender(dataObj.genero)
    //     // setPhone(dataObj.telefono)
    //     // setEmail(dataObj.correo)
    //     // setPregnant(dataObj.embarazo);
    // }

    // setParametersAsegurados()
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangeSelectCobertura = (event) => {
        setCobertura(event.target.value);
    };


    return (
        <div style={(props.isMobile ? fondoStyleMobile : fondoStyle)} >
            <Container fluid className="container-planes mw-container" >
                <div>
                    <Grid container spacing={1} direction="row" justifyContent="center">
                        <Grid item xs={10} md={11}>
                            <h1>¡Listo!</h1>
                            <p className="txt-2">Elige el plan de salud que mas te convenga</p>
                        </Grid>
                        {/* <Grid item xs={6} md={4}>
                            <p className="txt-resultados">(icono) Compartir resultados</p>
                        </Grid> */}

                    </Grid>

                    <div style={(props.isMobile ? bgTransparent : bgWhite)}>
                        <Grid container style={(props.isMobile ? opcionesAseguradoStyleMobile : opcionesAseguradoStyle)} className="display-block-mobile">
                            <Grid item xs={12} md={6}>
                                <h3 className="txt-titular">Titular</h3>
                                <EditarPerfilCotizadorModal />
                                <Grid container>
                                    <Grid item xs={4} >
                                        <h5 className="txt-info-titular">Nombre</h5>
                                        <p className="txt-informacion-cliente">{name}</p>
                                    </Grid>
                                    <Grid item xs={4} md={4}>
                                        <h5 className="txt-info-titular">Fecha de nacimiento</h5>
                                        <p className="txt-informacion-cliente">"{dateOfBirht}"</p>
                                    </Grid>
                                    <Grid item xs={4} md={4}>
                                        <h5 className="txt-info-titular">Genero</h5>
                                        <p className="txt-informacion-cliente">{gender}</p>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={6} md={4}>
                                        <h5 className="txt-info-titular">Tel&eacute;fono</h5>
                                        <p className="txt-informacion-cliente">{phone}</p>
                                    </Grid>
                                    <Grid item xs={6} md={4}>
                                        <h5 className="txt-info-titular">E-mail</h5>
                                        <p className="txt-informacion-cliente">{email}</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6} >
                                <h3 className="txt-titular">Estas viendo tus opciones en</h3>
                                <Grid>
                                    <Grid container>
                                        <Grid item xs={12} md={12}>
                                            <FormControl sx={{ m: 1, minWidth: 380 }}>
                                                <InputLabel id="demo-simple-select-helper-label">¿Qué quieres que te cubra?</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-helper-label"
                                                    id="demo-simple-select-helper"
                                                    value={cobertura}
                                                    label="Age"
                                                    onChange={handleChangeSelectCobertura}
                                                >
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={6} md={5}>
                                            <FormControl sx={{ m: 1, minWidth: 190 }}>
                                                <InputLabel id="demo-simple-select-helper-label">Planes</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-helper-label"
                                                    id="demo-simple-select-helper"
                                                    value={cobertura}
                                                    label="Age"
                                                    onChange={handleChangeSelectCobertura}
                                                >
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} md={5}>
                                            <FormControl sx={{ m: 1, minWidth: 190 }}>
                                                <InputLabel id="demo-simple-select-helper-label">Modalidad de pago</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-helper-label"
                                                    id="demo-simple-select-helper"
                                                    value={cobertura}
                                                    label="Age"
                                                    onChange={handleChangeSelectCobertura}
                                                >
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>

                        </Grid>
                        <Grid style={aseguradoAdicionalesStyle} className="hiddeOnMobile">
                            <span style={styleTextAseguradosAdicionales}>Asegurado(s) Adicional(es)</span>
                        </Grid>
                        <Grid className="showOnlyOnMobile btn-compartir-mobile">
                            <Button className="btn-compartir-mobile">Compartir</Button>
                        </Grid>
                        <Grid container spacing={5} >
                            <Grid item className="hiddeOnMobile">
                                <h4 className="txt-principal-cobertura">Coberturas</h4>
                                <p className="txt-coberturas">Suma asegurada
                                    <Tooltip title="Es la cantidad máxima de dinero que paga la aseguradora en caso de que tengas un accidente o enfermedad.">
                                        <img src="https://i.ibb.co/c1zyz04/tooltip.png" />
                                    </Tooltip>
                                </p>

                                <p className="txt-coberturas">Deducible
                                    <Tooltip title="Es el monto inicial fijo que debes cubrir para poder utilizar tu seguro en cada accidente o enfermedad.">
                                        <img src="https://i.ibb.co/c1zyz04/tooltip.png" />
                                    </Tooltip>
                                </p>

                                <p className="txt-coberturas">Coaseguro
                                    <Tooltip title="Es el porcentaje adicional que pagarás al descontar el deducible de tu accidente o enfermedad.">
                                        <img src="https://i.ibb.co/c1zyz04/tooltip.png" />
                                    </Tooltip>
                                </p>

                                <p className="txt-coberturas">Tope Coaseguro
                                    <Tooltip title="Es la cantidad máxima de dinero que deberás pagar de tu coaseguro por cada padecimiento.">
                                        <img src="https://i.ibb.co/c1zyz04/tooltip.png" />
                                    </Tooltip>
                                </p>
                                <p className="txt-coberturas">Maternidad
                                    <Tooltip title="Es la cobertura para gastos de maternidad, siempre y cuando estés asegurada antes del embarazo.">
                                        <img src="https://i.ibb.co/c1zyz04/tooltip.png" />
                                    </Tooltip>
                                </p>
                                <p className="txt-coberturas">Dental
                                    <Tooltip title="Son las coberturas extras incluidas por la aseguradora que no tienen costo para ti.">
                                        <img src="https://i.ibb.co/c1zyz04/tooltip.png" />
                                    </Tooltip>
                                </p>
                                <p className="txt-coberturas">Vision
                                    <Tooltip title="Son las coberturas extras incluidas por la aseguradora que no tienen costo para ti.">
                                        <img src="https://i.ibb.co/c1zyz04/tooltip.png" />
                                    </Tooltip>
                                </p>

                            </Grid>

                            <Grid item md={2} className="text-align-center">
                                <Paper className="contenido-tarjetas">
                                    <div className="w-55-mobile p-1">
                                        <img src={AxaSeguro} className="img-aseguradoras" />
                                    </div>
                                    <Divider orientation="vertical" flexItem className="vl-tarjetas" />
                                    <Divider />
                                    <div>
                                        <h4 className="txt-ca ">Costo anual:
                                            <h2 className="txt-cdad-anual">$11,946</h2>
                                            <p className="txt-msi">Meses sin Intereses</p>
                                        </h4>
                                        <div>
                                            <Button variant="contained" component="span" className="btn-comparar showOnlyOnMobile pt-15px-mobile">comparar</Button>
                                            <Button variant="contained" component="span" className="btn-elegir">¡Lo quiero!</Button>
                                        </div>
                                    </div>
                                    <div className="hiddeOnMobile">
                                        <h4 className="txt-cdad2 mt-20">$130,0000,000</h4>
                                        <h4 className="txt-cdad3 mt-20">$28,00</h4>
                                        <h4 className="txt-porsentaje mt-20">10% por padecimiento</h4>
                                        <h4 className=".txt-cdad4 mt-20">$40,000</h4>
                                        <h4 className=".txt-cdad5 mt-20">$15,000</h4>
                                        <h4 className=".txt-pd mt-20">Proteccion dental</h4>
                                        <h4 className=".txt-nhc mt-20">No hay cobertura</h4>
                                    </div>
                                </Paper>

                            </Grid>
                            <Grid item md={2} className="text-align-center pt-20px-mobile">
                                <Paper className="contenido-tarjetas ml-30">
                                    <div className="w-55-mobile p-5">
                                        <img src={GDSSeguro} className="img-aseguradoras" />
                                    </div>
                                    <Divider orientation="vertical" flexItem className="vl-tarjetas" />
                                    <Divider />
                                    <div>
                                        <h4 className="txt-ca ">Costo anual:
                                            <h2 className="txt-cdad-anual">$11,946</h2>
                                            <p className="txt-msi">Meses sin Intereses</p>
                                        </h4>
                                        <div className="cont-bnts">
                                            <Button variant="contained" component="span" className="btn-comparar showOnlyOnMobile pt-15px-mobile">comparar</Button>
                                            <Button variant="contained" component="span" className="btn-elegir">¡Lo quiero!</Button>
                                        </div>
                                    </div>
                                    <div className="hiddeOnMobile">
                                        <h4 className="txt-cdad2 mt-20">$130,0000,000</h4>
                                        <h4 className="txt-cdad3 mt-20">$28,00</h4>
                                        <h4 className="txt-porsentaje mt-20">10% por padecimiento</h4>
                                        <h4 className=".txt-cdad4 mt-20">$40,000</h4>
                                        <h4 className=".txt-cdad5 mt-20">$15,000</h4>
                                        <h4 className=".txt-pd mt-20">Proteccion dental</h4>
                                        <h4 className=".txt-nhc mt-20">No hay cobertura</h4>
                                    </div>
                                </Paper>

                            </Grid>
                            <Grid item md={2} className="text-align-center pt-20px-mobile">
                                <Paper className="contenido-tarjetas ml-60">
                                    <div className="w-55-mobile p-7">
                                        <img src={mapfre} className="img-aseguradoras" />
                                    </div>
                                    <Divider orientation="vertical" flexItem className="vl-tarjetas" />
                                    <Divider />
                                    <div>
                                        <h4 className="txt-ca ">Costo anual:
                                            <h2 className="txt-cdad-anual">$11,946</h2>
                                            <p className="txt-msi">Meses sin Intereses</p>
                                        </h4>
                                        <div>
                                            <Button variant="contained" component="span" className="btn-comparar showOnlyOnMobile pt-15px-mobile">comparar</Button>
                                            <Button variant="contained" component="span" className="btn-elegir">¡Lo quiero!</Button>
                                        </div>
                                    </div>
                                    <div className="hiddeOnMobile">
                                        <h4 className="txt-cdad2 mt-20">$130,0000,000</h4>
                                        <h4 className="txt-cdad3 mt-20">$28,00</h4>
                                        <h4 className="txt-porsentaje mt-20">10% por padecimiento</h4>
                                        <h4 className=".txt-cdad4 mt-20">$40,000</h4>
                                        <h4 className=".txt-cdad5 mt-20">$15,000</h4>
                                        <h4 className=".txt-pd mt-20">Proteccion dental</h4>
                                        <h4 className=".txt-nhc mt-20">No hay cobertura</h4>
                                    </div>
                                </Paper>


                            </Grid>
                            <Grid item md={2} className="text-align-center pt-20px-mobile">
                                <Paper className="contenido-tarjetas ml-90">
                                    <div className="w-55-mobile p-7">
                                    <img src={gnp} className="img-aseguradoras" />
                                    </div>
                                    <Divider orientation="vertical" flexItem className="vl-tarjetas" />
                                    <Divider />
                                    <div>
                                        <h4 className="txt-ca ">Costo anual:
                                            <h2 className="txt-cdad-anual">$11,946</h2>
                                            <p className="txt-msi">Meses sin Intereses</p>
                                        </h4>
                                        <div>
                                            <Button variant="contained" component="span" className="btn-comparar showOnlyOnMobile pt-15px-mobile">comparar</Button>
                                            <Button variant="contained" component="span" className="btn-elegir">¡Lo quiero!</Button>
                                        </div>
                                    </div>
                                    <div className="hiddeOnMobile">
                                        <h4 className="txt-cdad2 mt-20">$130,0000,000</h4>
                                        <h4 className="txt-cdad3 mt-20">$28,00</h4>
                                        <h4 className="txt-porsentaje mt-20">10% por padecimiento</h4>
                                        <h4 className=".txt-cdad4 mt-20">$40,000</h4>
                                        <h4 className=".txt-cdad5 mt-20">$15,000</h4>
                                        <h4 className=".txt-pd mt-20">Proteccion dental</h4>
                                        <h4 className=".txt-nhc mt-20">No hay cobertura</h4>
                                    </div>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </Container >
        </div >

    )
}